import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';

export default {
    id: 'coupons',
    version: 1,
    filterSpec: {
        redemptionCode: {
            type: FILTER_TYPES.text,
        },
        description: {
            type: FILTER_TYPES.text,
        },
        'discount.type': {
            label: 'Type',
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'Discount/type/enum',
            },
        },
        status: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'Coupon/status/enum',
            },
        },
        issuedTime: {
            label: 'Valid from',
            type: FILTER_TYPES.datetime,
        },
        expiredTime: {
            label: 'End',
            type: FILTER_TYPES.datetime,
        },
        createdTime: {
            label: 'Creation Time',
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            label: 'Last Update Time',
            type: FILTER_TYPES.datetime,
        },
    },
};
